import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { PermissionsDialog } from './model';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  private permissionsObs = new Subject<PermissionsDialog>();
  permissionsDialogObs = this.permissionsObs.asObservable();

  constructor() {}

  show(title:string, contentText:string ) {
    this.permissionsObs.next({show:true, title, contentText})
  }
  hide() {
    this.permissionsObs.next({show:false, title:'', contentText:''});
  }



}

